const GET_TICKETS = "GET_TICKETS";
const GET_TICKETS_SUCCESS = "GET_TICKETS_SUCCESS";
const GET_TICKETS_FAIL = "GET_TICKETS_FAIL";

const POST_TICKET = "POST_TICKET";
const POST_TICKET_SUCCESS = "POST_TICKET_SUCCESS";
const POST_TICKET_FAIL = "POST_TICKET_FAIL";

const GET_SUPPLIER_TICKETS = "GET_SUPPLIER_TICKETS";
const GET_SUPPLIER_TICKETS_SUCCESS = "GET_SUPPLIER_TICKETS_SUCCESS";
const GET_SUPPLIER_TICKETS_FAIL = "GET_SUPPLIER_TICKETS_FAIL";

const GET_CATEGORY = "GET_CATEGORY";
const GET_CATEGORY_SUCCESS = "GET_CATEGORY_SUCCESS";
const GET_CATEGORY_FAIL = "GET_CATEGORY_FAIL";

const GET_CUSTOM_FIELDS = "GET_CUSTOM_FIELDS";
const GET_CUSTOM_FIELDS_SUCCESS = "GET_CUSTOM_FIELDS_SUCCESS";
const GET_CUSTOM_FIELDS_FAIL = "GET_CUSTOM_FIELDS_FAIL";

const GET_COUNTRIES_HASH = "GET_COUNTRIES_HASH";
const GET_COUNTRIES_HASH_SUCCESS = "GET_COUNTRIES_HASH_SUCCESS";
const GET_COUNTRIES_HASH_FAIL = "GET_COUNTRIES_HASH_FAIL"

const GET_COMMENT_ATTACHMENTS = "GET_COMMENT_ATTACHMENTS";
const GET_COMMENT_ATTACHMENTS_SUCCESS = "GET_COMMENT_ATTACHMENTS_SUCCESS";
const GET_COMMENT_ATTACHMENTS_FAIL = "GET_COMMENT_ATTACHMENTS_FAIL";

const BASE_ENDPOINT = "/Integration";
const initialValues = {
  loading: false,
  hasError: false,
  data: {
    tickets: [],
    supplierTickets: [],
    categories: [],
    customFields: [],
    attachments: {},
    countriesHash: []
  }
};

const tickets = (state = initialValues, action) => {
  switch (action.type) {
    case GET_TICKETS: {
      return {
        ...state,
        loading: true,
      };
    }

    case GET_TICKETS_SUCCESS: {
      return {
        ...state,
        data: {
          ...state.data,
          tickets: action.payload.data
        },
        loading: false,
      };
    }

    case GET_TICKETS_FAIL: {
      return {
        ...state,
        loading: false,
        hasError: true,
      };
    }

    case POST_TICKET: {

      return {
        ...state,
        loading: true,
      }

    }

    case POST_TICKET_SUCCESS: {

      return {
        ...state,
        loading: false,
      }

    }

    case POST_TICKET_FAIL: {
      return {
        ...state,
        loading: false,
        hasError: true,
      };
    }

    case GET_SUPPLIER_TICKETS: {
      return {
        ...state,
        loading: true,
      };
    }

    case GET_SUPPLIER_TICKETS_SUCCESS: {
      return {
        ...state,
        data: {
          ...state.data,
          supplierTickets: action.payload.data
        },
        loading: false,
      };
    }

    case GET_SUPPLIER_TICKETS_FAIL: {
      return {
        ...state,
        loading: false,
        hasError: true,
      };
    }

    case GET_CATEGORY: {
      return {
        ...state,
        loading: true,
      };
    }

    case GET_CATEGORY_SUCCESS: {
      return {
        ...state,
        data: {
          ...state.data,
          categories: action.payload.data
        },
        loading: false,
      };
    }

    case GET_CATEGORY_FAIL: {
      return {
        ...state,
        loading: false,
        hasError: true,
      };
    }

    case GET_CUSTOM_FIELDS: {
      return {
        ...state,
        loading: true,
      };
    }

    case GET_CUSTOM_FIELDS_SUCCESS: {
      return {
        ...state,
        data: {
          ...state.data,
          customFields: action.payload.data
        },
        loading: false,
      };
    }

    case GET_CUSTOM_FIELDS_FAIL: {
      return {
        ...state,
        loading: false,
        hasError: true,
      };
    }

    case GET_COUNTRIES_HASH: {
      return {
        ...state,
        loading: true,
      };
    }

    case GET_COUNTRIES_HASH_SUCCESS: {
      return {
        ...state,
        data: {
          ...state.data,
          countriesHash: action.payload.data
        },
        loading: false,
      };
    }

    case GET_COUNTRIES_HASH_FAIL: {
      return {
        ...state,
        loading: false,
        hasError: true,
      };
    }

    case GET_COMMENT_ATTACHMENTS: {
      return {
        ...state,
        loading: true,
      };
    }

    case GET_COMMENT_ATTACHMENTS_SUCCESS: {
      return {
        ...state,
        data: {
          ...state.data,
          attachments: action.payload.data
        },
        loading: false,
      };
    }

    case GET_COMMENT_ATTACHMENTS_FAIL: {
      return {
        ...state,
        loading: false,
        hasError: true,
      };
    }

    default: {
      return state;
    }
  }
};

export const getTickets = (email) => {
  return {
    type: GET_TICKETS,
    payload: {
      request: {
        method: "GET",
        url: BASE_ENDPOINT + "/SupportTickets/ByEmailSupplier?emailSupplier=" + email,
      },
    },
  };
};

export const newTicket = (ticketData) => {
  return {
    type: POST_TICKET,
    payload: {
      request: {
        method: 'POST',
        url: BASE_ENDPOINT + `/SupportTicket`,
        data: ticketData,
        headers: {
          contentType: "multipart/form-data"
        }
      }
    }
  };
};

export const getSupplierTickets = (email) => {
  return {
    type: GET_SUPPLIER_TICKETS,
    payload: {
      request: {
        method: "GET",
        url: BASE_ENDPOINT + `/Supplier?email=${email}`,
      },
    },
  };
};

export const getCategory = (email) => {
  return {
    type: GET_CATEGORY,
    payload: {
      request: {
        method: "GET",
        url: BASE_ENDPOINT + `/Categories?email=${email}`,
      },
    },
  };
};

export const getCustomFields = (id) => {
  return {
    type: GET_CUSTOM_FIELDS,
    payload: {
      request: {
        method: "GET",
        url: BASE_ENDPOINT + `/CustomsFields/BySubCategoryId?subCategory=${id}`,
      },
    },
  };
};

export const getCountriesHash = () => {

  return {
    type: GET_COUNTRIES_HASH,
    payload: {
      request: {
        method: "GET",
        url: BASE_ENDPOINT + "/CustomField/CountriesSocieties"
      }
    }
  }
}

export const getAttachments = (idAttachment) => {
  return {
    type: GET_COMMENT_ATTACHMENTS,
    payload: {
      request: {
        method: "GET",
        url: BASE_ENDPOINT + "/SupportTicket/Attachment?idAttachment=" + idAttachment,
      },
    },
  };
};

export default tickets;
